
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $cbdf17c3d09bc906$export$863d7ca51b416cee;
var $cbdf17c3d09bc906$export$7b3cbda67be88f5f;
var $cbdf17c3d09bc906$export$ee7a15c61bfdeb11;
var $cbdf17c3d09bc906$export$f0199846ca09d4f9;
var $cbdf17c3d09bc906$var$single = $cbdf17c3d09bc906$export$863d7ca51b416cee = function(s) {
    return "'" + s.replace(/\\|'/g, function(m) {
        return "\\" + m;
    }) + "'";
};
var $cbdf17c3d09bc906$var$double = $cbdf17c3d09bc906$export$7b3cbda67be88f5f = function(s) {
    return '"' + s.replace(/\\|"/g, function(m) {
        return "\\" + m;
    }) + '"';
};
$cbdf17c3d09bc906$export$ee7a15c61bfdeb11 = function(s) {
    return /'/.test(s) ? $cbdf17c3d09bc906$var$double(s) : $cbdf17c3d09bc906$var$single(s);
};
$cbdf17c3d09bc906$export$f0199846ca09d4f9 = function(s) {
    var quote = s[0];
    var single = quote === "'";
    return s.substring(1, s.length - 1).replace(/\\\\/g, "\\").replace(single ? /\\'/g : /\\"/g, quote);
};


const $fdfd340aa13d9aca$var$nonSpaceRegex = /\S/g;
const $fdfd340aa13d9aca$var$keyEndRegex = /[\s=]/g;
function $fdfd340aa13d9aca$var$matchGRegexFrom(text, regex, index) {
    regex.lastIndex = index;
    return regex.exec(text);
}
function $fdfd340aa13d9aca$var$stringCharIsEscaped(text, index) {
    let escaped = false;
    while(index > 0){
        index -= 1;
        if (text[index] != "\\") break;
        escaped = !escaped;
    }
    return escaped;
}
function $fdfd340aa13d9aca$var$findClosingQuote(text, index) {
    // search for non escaped quote
    while(true){
        if ((index = text.indexOf('"', index)) < 0) return -1;
        if (!$fdfd340aa13d9aca$var$stringCharIsEscaped(text, index)) break;
        index += 1;
    }
    return index;
}
function $fdfd340aa13d9aca$var$parseAttributes(line, lineNumber, attributeStart) {
    const attributes = {};
    let index = attributeStart ?? line.indexOf(" ");
    if (index < 0) // no attributes
    return attributes;
    let match;
    while(match = $fdfd340aa13d9aca$var$matchGRegexFrom(line, $fdfd340aa13d9aca$var$nonSpaceRegex, index)){
        index = match.index;
        // find key end
        match = $fdfd340aa13d9aca$var$matchGRegexFrom(line, $fdfd340aa13d9aca$var$keyEndRegex, index);
        if (!match) throw new Error(`Unexpected "${line.slice(index)}" on line ${lineNumber}`);
        const key = line.slice(index, match.index);
        // find "="
        const eqIndex = line.indexOf("=", match.index);
        if (eqIndex < 0) throw new Error(`Attribute is missing "=" on line ${lineNumber}`);
        // find value start
        match = $fdfd340aa13d9aca$var$matchGRegexFrom(line, $fdfd340aa13d9aca$var$nonSpaceRegex, eqIndex + 1);
        if (!match) throw new Error(`Attribute is missing value on line ${lineNumber}`);
        // find value end
        let valueStart = match.index;
        let value = "";
        if (line[valueStart] == '"') {
            // quoted value
            let valueEnd = $fdfd340aa13d9aca$var$findClosingQuote(line, valueStart + 1);
            if (valueEnd < 0) throw new Error(`String missing closing quote on line ${lineNumber}`);
            valueEnd += 1;
            value = (0, $cbdf17c3d09bc906$export$f0199846ca09d4f9)(line.slice(valueStart, valueEnd));
            index = valueEnd;
        } else {
            // no quotes
            let valueEnd = line.indexOf(" ", valueStart);
            if (valueEnd < 0) valueEnd = line.length;
            value = line.slice(valueStart, valueEnd);
            index = valueEnd;
        }
        attributes[key] = value;
    }
    return attributes;
}
function $fdfd340aa13d9aca$var$nextWord(text, position) {
    let startIndex = text.length;
    for(let i = position ?? 0; i < text.length; i++)if (text[i] != " ") {
        startIndex = i;
        break;
    }
    let endIndex = text.length;
    for(let i = startIndex; i < text.length; i++)if (text[i] == " ") {
        endIndex = i;
        break;
    }
    return [
        startIndex,
        text.slice(startIndex, endIndex),
        text.slice(endIndex)
    ];
}
function $fdfd340aa13d9aca$export$e5a118b8056fd8d9(text) {
    const animations = [];
    const boomsheet = {
        version: "modern",
        animations: animations
    };
    let lineNumber = 0;
    let currentAnimation;
    let currentFrame;
    for (let line of text.split("\n")){
        line = line.trim();
        lineNumber += 1;
        if (line == "" || line.startsWith("#") || line.startsWith("!") || line.startsWith("imagePath") || line.startsWith("version")) continue;
        if (line.startsWith("anim ") || line.startsWith("animation ")) {
            const spaceIndex = line.indexOf(" ");
            if (spaceIndex == -1) throw new Error(`Animation is missing state name on line ${lineNumber}`);
            let [_, word, remainingLine] = $fdfd340aa13d9aca$var$nextWord(line.slice(spaceIndex));
            let state;
            if (word.startsWith("state=") || word == "state" && $fdfd340aa13d9aca$var$nextWord(remainingLine)[1].startsWith("=")) {
                // state="STATE"
                boomsheet.version = "legacy";
                const attributes = $fdfd340aa13d9aca$var$parseAttributes(line, lineNumber);
                state = attributes.state;
            } else if (word.startsWith('"')) {
                // quoted state
                remainingLine = line.slice(spaceIndex).trim();
                state = remainingLine.slice(1, $fdfd340aa13d9aca$var$findClosingQuote(remainingLine, 1));
            } else // unquoted state
            state = line.slice(spaceIndex).trim();
            if (state == undefined) throw new Error(`Animation is missing state name on line ${lineNumber}`);
            const animation = {
                state: state,
                frames: []
            };
            animations.push(animation);
            currentAnimation = animation;
        } else if (line.startsWith("frame") || line.startsWith("blank")) {
            if (!currentAnimation) throw new Error(`No animation state to associate frame with on line ${lineNumber}`);
            const attributes = $fdfd340aa13d9aca$var$parseAttributes(line, lineNumber);
            const frame = {
                x: parseFloat(attributes.x) || 0,
                y: parseFloat(attributes.y) || 0,
                w: parseFloat(attributes.w) || 0,
                h: parseFloat(attributes.h) || 0,
                originx: parseFloat(attributes.originx) || 0,
                originy: parseFloat(attributes.originy) || 0,
                flipx: parseInt(attributes.flipx) == 1,
                flipy: parseInt(attributes.flipy) == 1,
                duration: attributes.duration || attributes.dur || "",
                points: []
            };
            currentAnimation.frames.push(frame);
            currentFrame = frame;
        } else if (line.startsWith("point ")) {
            if (!currentFrame) throw new Error(`No frame to associate point with on line ${lineNumber}`);
            let attributesIndex = 6;
            // see if we start with a label in quotes or if we need to just read attributes
            const [wordIndex, word, _] = $fdfd340aa13d9aca$var$nextWord(line, attributesIndex);
            let label;
            if (word.startsWith('"')) {
                // point starts with label in quotes and not within a named attribute
                const labelEndIndex = $fdfd340aa13d9aca$var$findClosingQuote(line, wordIndex + 1);
                label = line.slice(wordIndex + 1, labelEndIndex);
                attributesIndex = labelEndIndex + 1;
            }
            // read attributes
            const attributes = $fdfd340aa13d9aca$var$parseAttributes(line, lineNumber, attributesIndex);
            label = label ?? attributes.label;
            if (!label) throw new Error(`Point is missing label on line ${lineNumber}`);
            const point = {
                label: label,
                x: parseFloat(attributes.x),
                y: parseFloat(attributes.y)
            };
            currentFrame.points.push(point);
        } else {
            const wordEnd = line.indexOf(" ");
            const word = wordEnd < 0 ? line : line.slice(0, wordEnd);
            throw new Error(`Unexpected "${word}" on line ${lineNumber}`);
        }
    }
    return boomsheet;
}
function $fdfd340aa13d9aca$export$981e88379b359e25(json) {
    if (!Array.isArray(json.frames)) throw "Only Array format is supported for Aseprite sheets";
    const animations = [];
    const boomsheet = {
        version: "modern",
        animations: animations
    };
    let frameTags = json.meta.frameTags;
    if (!Array.isArray(frameTags) || frameTags.length == 0) frameTags = [
        {
            name: "DEFAULT",
            from: 0,
            to: Math.max(json.frames.length - 1, 0),
            direction: "forward"
        }
    ];
    const asepriteFrames = json.frames;
    for (const frameTag of frameTags){
        const frames = [];
        for(let i = frameTag.from; i <= frameTag.to; i++){
            const aseFrame = asepriteFrames[i];
            const frame = {
                x: aseFrame.frame.x,
                y: aseFrame.frame.y,
                w: aseFrame.frame.w,
                h: aseFrame.frame.h,
                originx: -(aseFrame.spriteSourceSize?.x ?? 0),
                originy: -(aseFrame.spriteSourceSize?.y ?? 0),
                flipx: false,
                flipy: false,
                duration: (aseFrame.duration / 1000).toString(),
                points: []
            };
            frames.push(frame);
        }
        if (frameTag.direction.toLowerCase().includes("reverse")) frames.reverse();
        animations.push({
            state: frameTag.name,
            frames: frames
        });
    }
    return boomsheet;
}
function $fdfd340aa13d9aca$var$serializeObject(name, object, options = {
    quoteAllValues: true
}) {
    const text = [
        name
    ];
    for(const key in object){
        const value = object[key];
        let renamedKey = key;
        if (options.renamedKeys) renamedKey = options.renamedKeys[key] || key;
        switch(typeof value){
            case "string":
                if (value != "") {
                    text.push(" ");
                    text.push(renamedKey);
                    text.push("=");
                    if (options.quoteAllValues || value.includes('"') || value.includes(" ")) text.push((0, $cbdf17c3d09bc906$export$7b3cbda67be88f5f)(value));
                    else text.push(value);
                }
                break;
            case "number":
                if (value != 0) {
                    if (options.quoteAllValues) text.push(` ${renamedKey}="${value}"`);
                    else text.push(` ${renamedKey}=${value}`);
                }
                break;
            case "boolean":
                if (value == true) {
                    text.push(" ");
                    text.push(renamedKey);
                    if (options.quoteAllValues) text.push('="1"');
                    else text.push("=1");
                }
                break;
            case "object":
                if (Array.isArray(value)) break;
            default:
                throw new Error(`Unexpected ${typeof value} for ${renamedKey}`);
        }
    }
    return text.join("");
}
function $fdfd340aa13d9aca$export$ea55e312597ee95e(boomsheet) {
    const lines = [];
    const options = {
        quoteAllValues: true
    };
    if (boomsheet.version == "modern") {
        options.quoteAllValues = false;
        options.renamedKeys = {
            duration: "dur"
        };
    }
    for (const animation of boomsheet.animations){
        if (boomsheet.version == "modern") lines.push("anim " + animation.state);
        else lines.push($fdfd340aa13d9aca$var$serializeObject("animation", animation, options));
        for (const frame of animation.frames){
            lines.push($fdfd340aa13d9aca$var$serializeObject("frame", frame, options));
            for (const point of frame.points)lines.push($fdfd340aa13d9aca$var$serializeObject("point", point, options));
        }
        lines.push("");
    }
    return lines.join("\n");
}
function $fdfd340aa13d9aca$export$d459b87f0a545072(boomsheet) {
    const lines = [];
    const options = {
        quoteAllValues: true
    };
    if (boomsheet.version == "modern") {
        options.quoteAllValues = false;
        options.renamedKeys = {
            duration: "dur"
        };
    }
    for (const animation of boomsheet.animations){
        let pendingLines = [];
        let pushedAnimation = false;
        if (boomsheet.version == "modern") pendingLines.push("anim " + animation.state);
        else pendingLines.push($fdfd340aa13d9aca$var$serializeObject("animation", animation, options));
        for (const frame of animation.frames){
            const simplifiedFrame = {
                x: 0,
                y: 0,
                w: 0,
                h: 0,
                originx: 0,
                originy: 0,
                flipx: false,
                flipy: false,
                duration: frame.duration,
                points: []
            };
            pendingLines.push($fdfd340aa13d9aca$var$serializeObject("frame", simplifiedFrame, options));
            if (frame.points && frame.points.length > 0) {
                lines.push(...pendingLines);
                pendingLines = [];
                pushedAnimation = true;
                for (const point of frame.points){
                    const shiftedPoint = {
                        label: point.label,
                        x: point.x - frame.originx,
                        y: point.y - frame.originy
                    };
                    lines.push($fdfd340aa13d9aca$var$serializeObject("point", shiftedPoint, options));
                }
            }
        }
        if (pushedAnimation) lines.push("");
    }
    return lines.join("\n");
}


function $a9cec9f5d2c68d09$export$cc0e7cb90ac4067f(file) {
    return new Promise((resolve, reject)=>{
        // load file as data url, then load as image
        const reader = new FileReader();
        reader.onload = function() {
            // load image
            const image = new Image();
            image.src = reader.result;
            image.onload = function() {
                resolve(image);
            };
            image.onerror = function() {
                reject(new Error(`Failed to load "${file.name}"`));
            };
        };
        reader.onerror = function() {
            reject(new Error(`Failed to load "${file.name}: ${reader.error}"`));
        };
        reader.readAsDataURL(file);
    });
}
function $a9cec9f5d2c68d09$export$b4f0996f721d43ec(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(new Error(`Failed to load "${file.name}: ${reader.error}"`));
        };
        reader.readAsText(file);
    });
}


var $7bcff58d1f5524c8$exports = {};
"use strict";
var $06f5eb59911c96c0$exports = {};
/******************************************************************************

This is a binary tree based bin packing algorithm that is more complex than
the simple Packer (packer.js). Instead of starting off with a fixed width and
height, it starts with the width and height of the first block passed and then
grows as necessary to accomodate each subsequent block. As it grows it attempts
to maintain a roughly square ratio by making 'smart' choices about whether to
grow right or down.

When growing, the algorithm can only grow to the right OR down. Therefore, if
the new block is BOTH wider and taller than the current target then it will be
rejected. This makes it very important to initialize with a sensible starting
width and height. If you are providing sorted input (largest first) then this
will not be an issue.

A potential way to solve this limitation would be to allow growth in BOTH
directions at once, but this requires maintaining a more complex tree
with 3 children (down, right and center) and that complexity can be avoided
by simply chosing a sensible starting block.

Best results occur when the input blocks are sorted by height, or even better
when sorted by max(width,height).

Inputs:
------

	blocks: array of any objects that have .w and .h attributes

Outputs:
-------

	marks each block that fits with a .fit attribute pointing to a
	node with .x and .y coordinates

Example:
-------

	var blocks = [
		{ w: 100, h: 100 },
		{ w: 100, h: 100 },
		{ w:  80, h:  80 },
		{ w:  80, h:  80 },
		etc
		etc
	];

	var packer = new GrowingPacker();
	packer.fit(blocks);

	for(var n = 0 ; n < blocks.length ; n++) {
		var block = blocks[n];
		if (block.fit) {
			Draw(block.fit.x, block.fit.y, block.w, block.h);
		}
	}


******************************************************************************/ var $06f5eb59911c96c0$var$GrowingPacker = function() {};
$06f5eb59911c96c0$var$GrowingPacker.prototype = {
    fit: function(blocks) {
        var n, node, block, len = blocks.length, fit;
        var width = len > 0 ? blocks[0].width : 0;
        var height = len > 0 ? blocks[0].height : 0;
        this.root = {
            x: 0,
            y: 0,
            width: width,
            height: height
        };
        for(n = 0; n < len; n++){
            block = blocks[n];
            if (node = this.findNode(this.root, block.width, block.height)) {
                fit = this.splitNode(node, block.width, block.height);
                block.x = fit.x;
                block.y = fit.y;
            } else {
                fit = this.growNode(block.width, block.height);
                block.x = fit.x;
                block.y = fit.y;
            }
        }
    },
    findNode: function(root, width, height) {
        if (root.used) return this.findNode(root.right, width, height) || this.findNode(root.down, width, height);
        else if (width <= root.width && height <= root.height) return root;
        else return null;
    },
    splitNode: function(node, width, height) {
        node.used = true;
        node.down = {
            x: node.x,
            y: node.y + height,
            width: node.width,
            height: node.height - height
        };
        node.right = {
            x: node.x + width,
            y: node.y,
            width: node.width - width,
            height: height
        };
        return node;
    },
    growNode: function(width, height) {
        var canGrowDown = width <= this.root.width;
        var canGrowRight = height <= this.root.height;
        var shouldGrowRight = canGrowRight && this.root.height >= this.root.width + width; // attempt to keep square-ish by growing right when height is much greater than width
        var shouldGrowDown = canGrowDown && this.root.width >= this.root.height + height; // attempt to keep square-ish by growing down  when width  is much greater than height
        if (shouldGrowRight) return this.growRight(width, height);
        else if (shouldGrowDown) return this.growDown(width, height);
        else if (canGrowRight) return this.growRight(width, height);
        else if (canGrowDown) return this.growDown(width, height);
        else return null; // need to ensure sensible root starting size to avoid this happening
    },
    growRight: function(width, height) {
        this.root = {
            used: true,
            x: 0,
            y: 0,
            width: this.root.width + width,
            height: this.root.height,
            down: this.root,
            right: {
                x: this.root.width,
                y: 0,
                width: width,
                height: this.root.height
            }
        };
        var node;
        if (node = this.findNode(this.root, width, height)) return this.splitNode(node, width, height);
        else return null;
    },
    growDown: function(width, height) {
        this.root = {
            used: true,
            x: 0,
            y: 0,
            width: this.root.width,
            height: this.root.height + height,
            down: {
                x: 0,
                y: this.root.height,
                width: this.root.width,
                height: height
            },
            right: this.root
        };
        var node;
        if (node = this.findNode(this.root, width, height)) return this.splitNode(node, width, height);
        else return null;
    }
};
$06f5eb59911c96c0$exports = $06f5eb59911c96c0$var$GrowingPacker;


$7bcff58d1f5524c8$exports = function(items, options) {
    options = options || {};
    var packer = new $06f5eb59911c96c0$exports();
    var inPlace = options.inPlace || false;
    // Clone the items.
    var newItems = items.map(function(item) {
        return inPlace ? item : {
            width: item.width,
            height: item.height,
            item: item
        };
    });
    newItems = newItems.sort(function(a, b) {
        // TODO: check that each actually HAS a width and a height.
        // Sort based on the size (area) of each block.
        return b.width * b.height - a.width * a.height;
    });
    packer.fit(newItems);
    var w = newItems.reduce(function(curr, item) {
        return Math.max(curr, item.x + item.width);
    }, 0);
    var h = newItems.reduce(function(curr, item) {
        return Math.max(curr, item.y + item.height);
    }, 0);
    var ret = {
        width: w,
        height: h
    };
    if (!inPlace) ret.items = newItems;
    return ret;
};


function $f2b72c385c32c0e1$export$2afdae6c40900d48(a, b) {
    const aIsLeft = a.x + a.w <= b.x;
    const aIsRight = a.x >= b.x + b.w;
    const aIsAbove = a.y + a.h <= b.y;
    const aIsBelow = a.y >= b.y + b.h;
    return !(aIsLeft || aIsRight || aIsAbove || aIsBelow);
}
function $f2b72c385c32c0e1$export$2b26f95af2147236(rect, x, y) {
    return x >= rect.x && x < rect.x + rect.w && y >= rect.y && y < rect.y + rect.h;
}


function $c85964dfd97e8768$var$updateBounds(group) {
    const firstFrame = group.frames[0];
    let minX = firstFrame.x;
    let minY = firstFrame.y;
    let maxX = firstFrame.x + firstFrame.w;
    let maxY = firstFrame.y + firstFrame.h;
    for(let i = 1; i < group.frames.length; i++){
        const frame = group.frames[i];
        minX = Math.min(minX, frame.x);
        minY = Math.min(minY, frame.y);
        maxX = Math.max(maxX, frame.x + frame.w);
        maxY = Math.max(maxY, frame.y + frame.h);
    }
    group.x = minX;
    group.y = minY;
    group.w = maxX - minX;
    group.h = maxY - minY;
}
// create a single group, removes frames from the passed list
function $c85964dfd97e8768$var$takeGroup(frames) {
    const group = {
        x: 0,
        y: 0,
        w: 0,
        h: 0,
        frames: [
            frames.pop()
        ]
    };
    $c85964dfd97e8768$var$updateBounds(group);
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (!(0, $f2b72c385c32c0e1$export$2afdae6c40900d48)(group, frame)) continue;
        if (!group.frames.some((f)=>(0, $f2b72c385c32c0e1$export$2afdae6c40900d48)(f, frame))) continue;
        // take frame by swap remove
        frames[i] = frames[frames.length - 1];
        frames.pop();
        group.frames.push(frame);
        $c85964dfd97e8768$var$updateBounds(group);
    }
    return group;
}
function $c85964dfd97e8768$export$21bf01f8bab81bf3(group, x, y) {
    const shiftX = x - group.x;
    const shiftY = y - group.y;
    group.x = x;
    group.y = y;
    for (const frame of group.frames){
        frame.x += shiftX;
        frame.y += shiftY;
    }
}
function $c85964dfd97e8768$export$2e2bcd8739ae039(animations) {
    const frames = animations.flatMap((animation)=>animation.frames);
    const groups = [];
    while(frames.length > 0)groups.push($c85964dfd97e8768$var$takeGroup(frames));
    return groups;
}



class $240a416b6ffb223f$export$2e2bcd8739ae039 {
    #originalSheet;
    #sheet;
    #frameGroups;
    #selectedGroups;
    #canvas;
    #ctx;
    #frameCanvas;
    #frameCtx;
    #expandingSelection;
    #mouseDown;
    #selectionRect;
    #dragStartX;
    #dragStartY;
    constructor(canvas){
        this.#originalSheet = {};
        this.#sheet = {};
        this.#frameGroups = [];
        this.#selectedGroups = [];
        this.#expandingSelection = false;
        this.#mouseDown = false;
        this.#dragStartX = 0;
        this.#dragStartY = 0;
        this.#canvas = canvas;
        this.#ctx = canvas.getContext("2d");
        this.#frameCanvas = document.createElement("canvas");
        this.#frameCtx = this.#frameCanvas.getContext("2d");
        this.#frameCtx.globalCompositeOperation = "copy";
        let mouseX = 0;
        let mouseY = 0;
        const resolveMousePosition = (event)=>{
            const boundingRect = canvas.getBoundingClientRect();
            const inverseScale = canvas.width / boundingRect.width;
            mouseX = Math.floor((event.clientX - boundingRect.left) * inverseScale);
            mouseY = Math.floor((event.clientY - boundingRect.top) * inverseScale);
        };
        this.#canvas.addEventListener("mousedown", (event)=>{
            resolveMousePosition(event);
            this.#mouseDown = true;
            this.#dragStartX = mouseX;
            this.#dragStartY = mouseY;
            const selectedExisting = this.#selectedGroups.some(({ work: work })=>(0, $f2b72c385c32c0e1$export$2b26f95af2147236)(work, mouseX, mouseY));
            if (selectedExisting) this.#expandingSelection = false;
            else {
                // redefine selection
                this.#selectedGroups = this.#frameGroups.filter(({ work: work })=>(0, $f2b72c385c32c0e1$export$2b26f95af2147236)(work, mouseX, mouseY));
                this.#expandingSelection = this.#selectedGroups.length == 0;
            }
            this.render();
        });
        document.body.addEventListener("mousemove", (event)=>{
            if (!this.#mouseDown) return;
            const lastX = mouseX;
            const lastY = mouseY;
            resolveMousePosition(event);
            if (this.#expandingSelection) {
                const minX = Math.min(mouseX, this.#dragStartX);
                const minY = Math.min(mouseY, this.#dragStartY);
                const maxX = Math.max(mouseX, this.#dragStartX);
                const maxY = Math.max(mouseY, this.#dragStartY);
                const rect = {
                    x: minX,
                    y: minY,
                    w: maxX - minX + 1,
                    h: maxY - minY + 1
                };
                this.#selectionRect = rect;
                this.#selectedGroups = this.#frameGroups.filter(({ work: work })=>(0, $f2b72c385c32c0e1$export$2afdae6c40900d48)(rect, work));
            } else {
                const shiftX = mouseX - lastX;
                const shiftY = mouseY - lastY;
                this.#shiftSelections(shiftX, shiftY);
            }
            this.render();
        });
        document.body.addEventListener("mouseup", ()=>{
            if (this.#mouseDown) {
                this.#mouseDown = false;
                this.#selectionRect = undefined;
                this.render();
            }
        });
        this.#canvas.addEventListener("keydown", (event)=>{
            let shiftX = 0;
            let shiftY = 0;
            switch(event.code){
                case "KeyA":
                case "ArrowLeft":
                    shiftX -= 1;
                    break;
                case "KeyD":
                case "ArrowRight":
                    shiftX += 1;
                    break;
                case "KeyW":
                case "ArrowUp":
                    shiftY -= 1;
                    break;
                case "KeyS":
                case "ArrowDown":
                    shiftY += 1;
                    break;
            }
            if (shiftX == 0 && shiftY == 0) return;
            event.preventDefault();
            if (event.shiftKey) this.#accordionSelections(shiftX, shiftY);
            else this.#shiftSelections(shiftX, shiftY);
            this.render();
        });
    }
    #shiftSelections(shiftX, shiftY) {
        for (const { work: work } of this.#selectedGroups)(0, $c85964dfd97e8768$export$21bf01f8bab81bf3)(work, work.x + shiftX, work.y + shiftY);
    }
    #accordionSelections(shiftX, shiftY) {
        if (this.#selectedGroups.length == 0) return;
        // x
        this.#selectedGroups.sort((a, b)=>a.work.x - b.work.x);
        let lastX = this.#selectedGroups[0].work.x;
        let currentShiftX = 0;
        for (const { work: work } of this.#selectedGroups){
            if (work.x != lastX) {
                lastX = work.x;
                currentShiftX += shiftX;
            }
            (0, $c85964dfd97e8768$export$21bf01f8bab81bf3)(work, work.x + currentShiftX, work.y);
        }
        // y
        this.#selectedGroups.sort((a, b)=>a.work.y - b.work.y);
        let lastY = this.#selectedGroups[0].work.y;
        let currentShiftY = 0;
        for (const { work: work } of this.#selectedGroups){
            if (work.y != lastY) {
                lastY = work.y;
                currentShiftY += shiftY;
            }
            (0, $c85964dfd97e8768$export$21bf01f8bab81bf3)(work, work.x, work.y + currentShiftY);
        }
    }
    loadSheet(sheet) {
        const sourceImage = sheet.image;
        // update canvas bounds
        this.#canvas.width = sourceImage.width;
        this.#canvas.height = sourceImage.height;
        // can't use structured clone on image element
        sheet.image = undefined;
        this.#originalSheet = sheet;
        this.#sheet = structuredClone(sheet);
        // put the image back
        sheet.image = sourceImage;
        this.#sheet.image = sourceImage;
        const groups = (0, $c85964dfd97e8768$export$2e2bcd8739ae039)(this.#sheet.boomsheet.animations);
        const packed = (0, (/*@__PURE__*/$parcel$interopDefault($7bcff58d1f5524c8$exports)))(groups.map((group)=>({
                width: group.w + 2,
                height: group.h + 2,
                group: group
            })));
        this.#frameGroups = [];
        for (const item of packed.items){
            const work = item.item.group;
            const packed = structuredClone(work);
            (0, $c85964dfd97e8768$export$21bf01f8bab81bf3)(packed, item.x + 1, item.y + 1);
            this.#frameGroups.push({
                work: work,
                packed: packed
            });
        }
        this.#updateFrameSource(packed.width, packed.height);
        this.render();
    }
    #updateFrameSource(width, height) {
        const sourceImage = this.#sheet.image;
        // update canvas bounds
        this.#frameCanvas.width = width;
        this.#frameCanvas.height = height;
        // create frame source
        for (const { work: work, packed: packed } of this.#frameGroups)for(let i = 0; i < packed.frames.length; i++){
            const sourceFrame = work.frames[i];
            const destFrame = packed.frames[i];
            const w = sourceFrame.w;
            const h = sourceFrame.h;
            this.#frameCtx.drawImage(sourceImage, sourceFrame.x, sourceFrame.y, w, h, destFrame.x, destFrame.y, w, h);
        }
    }
    unpack() {
        // can't use structured clone on image element
        const image = this.#originalSheet.image;
        this.#originalSheet.image = undefined;
        this.#sheet = structuredClone(this.#originalSheet);
        // put the image back
        this.#sheet.image = image;
        this.#originalSheet.image = image;
        if (!this.#sheet.boomsheet) return;
        // build frame groups and move frames
        this.#frameGroups = [];
        for (const animation of this.#sheet.boomsheet.animations)for (const frame of animation.frames){
            const { x: x, y: y, w: w, h: h } = frame;
            const work = {
                x: x,
                y: y,
                w: w,
                h: h,
                frames: [
                    frame
                ]
            };
            const packed = structuredClone(work);
            this.#frameGroups.push({
                work: work,
                packed: packed
            });
        }
        if (image) this.#updateFrameSource(image.width, image.height);
        // move frames
        let frameGroupIndex = 0;
        let placeX = 1;
        let placeY = 1;
        let nextY = placeY;
        let width = placeX;
        for (const animation of this.#sheet.boomsheet.animations){
            for (const frame of animation.frames){
                const frameGroup = this.#frameGroups[frameGroupIndex];
                (0, $c85964dfd97e8768$export$21bf01f8bab81bf3)(frameGroup.work, placeX, placeY);
                placeX += frame.w + 1;
                nextY = Math.max(nextY, placeY + frame.h + 1);
                width = Math.max(width, placeX);
                frameGroupIndex++;
            }
            placeX = 1;
            placeY = nextY;
        }
        // update canvas bounds
        this.#canvas.width = width;
        this.#canvas.height = placeY;
        this.render();
    }
    render() {
        this.#ctx.clearRect(0, 0, this.#canvas.width, this.#canvas.height);
        this.#renderFrames(this.#ctx);
        this.#renderOutlines();
    }
    #renderFrames(ctx) {
        for (const { work: work, packed: packed } of this.#frameGroups)for(let i = 0; i < packed.frames.length; i++){
            const sourceFrame = packed.frames[i];
            const destFrame = work.frames[i];
            const w = sourceFrame.w;
            const h = sourceFrame.h;
            ctx.drawImage(this.#frameCanvas, sourceFrame.x, sourceFrame.y, w, h, destFrame.x, destFrame.y, w, h);
        }
    }
    #renderOutlines() {
        const ctx = this.#ctx;
        ctx.strokeStyle = "lime";
        ctx.fillStyle = "rgba(0, 255, 0, 0.2)";
        const renderRect = (x, y, w, h)=>{
            ctx.beginPath();
            ctx.rect(x + 0.5, y + 0.5, w, h);
            ctx.fill();
            ctx.stroke();
        };
        for (const group of this.#frameGroups){
            ctx.globalAlpha = this.#selectedGroups.includes(group) ? 1.0 : 0.2;
            const { x: x, y: y, w: w, h: h } = group.work;
            renderRect(x, y, w - 1, h - 1);
        }
        ctx.globalAlpha = 1.0;
        if (this.#selectionRect) {
            const { x: x, y: y, w: w, h: h } = this.#selectionRect;
            renderRect(x, y, w - 1, h - 1);
        }
    }
    renderOutput(canvas) {
        canvas.width = this.#canvas.width;
        canvas.height = this.#canvas.height;
        const ctx = canvas.getContext("2d");
        this.#renderFrames(ctx);
    }
    boomsheet() {
        return this.#sheet.boomsheet;
    }
}


function $d56fe29905c32fe3$export$9b2ff4fb61b7dfca(sheet) {
    if (sheet.animationError) return sheet.animationError;
    else if (sheet.imageError) return sheet.imageError;
    else if (!sheet.boomsheet) return "Missing .animation file";
    else if (!sheet.image) return "Missing image file";
}


const $b4e14b6b8da86996$var$canvas = document.querySelector("#input canvas");
const $b4e14b6b8da86996$var$workspace = new (0, $240a416b6ffb223f$export$2e2bcd8739ae039)($b4e14b6b8da86996$var$canvas);
const $b4e14b6b8da86996$var$pendingSheet = {};
const $b4e14b6b8da86996$var$animationOutputElement = document.getElementById("animation-output");
const $b4e14b6b8da86996$var$pointsOutputElement = document.getElementById("points-output");
function $b4e14b6b8da86996$var$logError(error) {
    console.error(error);
    alert(error);
}
document.getElementById("unpack-button").onclick = function() {
    if (confirm("Are you sure? This will reorganize every frame and possibly create duplicate frames.")) $b4e14b6b8da86996$var$workspace.unpack();
};
document.getElementById("bake-button").onclick = function() {
    const canvas = document.querySelector("#output canvas");
    const textarea = document.querySelector("#output textarea");
    try {
        $b4e14b6b8da86996$var$workspace.renderOutput(canvas);
        const boomsheet = $b4e14b6b8da86996$var$workspace.boomsheet();
        if (boomsheet) {
            $b4e14b6b8da86996$var$animationOutputElement.value = (0, $fdfd340aa13d9aca$export$ea55e312597ee95e)(boomsheet);
            $b4e14b6b8da86996$var$pointsOutputElement.value = (0, $fdfd340aa13d9aca$export$d459b87f0a545072)(boomsheet);
        } else {
            $b4e14b6b8da86996$var$animationOutputElement.value = "";
            $b4e14b6b8da86996$var$pointsOutputElement.value = "";
        }
    } catch (error) {
        $b4e14b6b8da86996$var$logError(error);
    }
};
document.body.addEventListener("dragover", (event)=>event.preventDefault());
document.body.addEventListener("drop", (event)=>{
    const items = event.dataTransfer?.items;
    if (!items) return;
    event.preventDefault();
    const files = [];
    for (const item of items){
        const file = item.getAsFile();
        if (file) files.push(file);
    }
    $b4e14b6b8da86996$var$loadFiles(files).catch($b4e14b6b8da86996$var$logError).finally(()=>{
        const errorMessage = (0, $d56fe29905c32fe3$export$9b2ff4fb61b7dfca)($b4e14b6b8da86996$var$pendingSheet);
        const errorElement = document.querySelector("#input .error-text");
        errorElement.innerText = errorMessage || "";
        if (!errorMessage) $b4e14b6b8da86996$var$workspace.loadSheet($b4e14b6b8da86996$var$pendingSheet);
    });
});
async function $b4e14b6b8da86996$var$loadFiles(files) {
    for (const file of files){
        if (file.name.endsWith(".png")) try {
            $b4e14b6b8da86996$var$pendingSheet.image = await (0, $a9cec9f5d2c68d09$export$cc0e7cb90ac4067f)(file);
            $b4e14b6b8da86996$var$pendingSheet.imageError = undefined;
        } catch (error) {
            console.error(error);
            $b4e14b6b8da86996$var$pendingSheet.imageError = error.toString();
        }
        else if (file.name.endsWith(".animation") || file.name.endsWith(".anim")) try {
            const text = await (0, $a9cec9f5d2c68d09$export$b4f0996f721d43ec)(file);
            $b4e14b6b8da86996$var$pendingSheet.boomsheet = (0, $fdfd340aa13d9aca$export$e5a118b8056fd8d9)(text);
            $b4e14b6b8da86996$var$pendingSheet.animationError = undefined;
        } catch (error) {
            console.error(error);
            $b4e14b6b8da86996$var$pendingSheet.animationError = error.toString();
        }
        else if (file.name.endsWith(".json")) try {
            const text = await (0, $a9cec9f5d2c68d09$export$b4f0996f721d43ec)(file);
            const json = JSON.parse(text);
            if (typeof json == "object" && Array.isArray(json.frames)) {
                const originString = prompt("Origin:", "0,0") ?? "0,0";
                let [originx, originy] = originString.split(",").map((s)=>parseFloat(s));
                originx ??= 0;
                originy ??= 0;
                $b4e14b6b8da86996$var$pendingSheet.boomsheet = (0, $fdfd340aa13d9aca$export$981e88379b359e25)(json);
                for (const animation of $b4e14b6b8da86996$var$pendingSheet.boomsheet.animations)for (const frame of animation.frames){
                    frame.originx += originx;
                    frame.originy += originy;
                }
                $b4e14b6b8da86996$var$pendingSheet.animationError = undefined;
            }
        } catch (error) {
            console.error(error);
            $b4e14b6b8da86996$var$pendingSheet.animationError = error.toString();
        }
    }
}
document.querySelectorAll("input[name='animation-output-options']").forEach((input)=>input.addEventListener("change", $b4e14b6b8da86996$var$updateVisibleAnimationOutput));
function $b4e14b6b8da86996$var$updateVisibleAnimationOutput() {
    const input = document.querySelector("input[name='animation-output-options']:checked");
    const textboxes = [
        $b4e14b6b8da86996$var$animationOutputElement,
        $b4e14b6b8da86996$var$pointsOutputElement
    ];
    const visibleId = input.value + "-output";
    for (const textbox of textboxes)textbox.style.display = textbox.id == visibleId ? "" : "none";
}
$b4e14b6b8da86996$var$updateVisibleAnimationOutput();


//# sourceMappingURL=index.d94c0b41.js.map
